/* Shopify OS 2.0: section-scoped UI, reliable editor reloads, exclusive LP discount code. */
(function () {
  'use strict';
  function money(cents, currency) {
    return new Intl.NumberFormat('ja-JP', { style: 'currency', currency: currency || 'JPY' }).format(cents / 100);
  }
  function discountAmount(price, rate, currency) {
    // Shopify amounts have two implied decimal places, including JPY.
    var raw = price * rate / 100;
    return currency === 'JPY' ? Math.floor(raw / 100) * 100 : Math.floor(raw);
  }
  function parseSaleDate(value) {
    if (value === null || value === undefined) return null;
    var raw = String(value).trim();
    if (!raw) return null;

    // Accept the ISO format shown in the editor, plus common Japanese inputs such as
    // 2026/10/13 12:00 and 2026/10/25 24:00. If no timezone is supplied, use JST.
    var match = raw.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})[ T](\d{1,2}):(\d{2})(?::(\d{2}))?(?:\s*(Z|[+-]\d{2}:?\d{2}))?$/i);
    if (match) {
      var year = Number(match[1]);
      var month = Number(match[2]);
      var day = Number(match[3]);
      var hour = Number(match[4]);
      var minute = Number(match[5]);
      var second = Number(match[6] || 0);
      if (month < 1 || month > 12 || day < 1 || day > 31 || hour < 0 || hour > 24 || minute < 0 || minute > 59 || second < 0 || second > 59) return NaN;
      if (hour === 24 && (minute !== 0 || second !== 0)) return NaN;

      var zone = match[7] || '+09:00';
      var offsetMinutes = 0;
      if (zone.toUpperCase() !== 'Z') {
        var sign = zone.charAt(0) === '-' ? -1 : 1;
        var parts = zone.slice(1).replace(':', '');
        var zoneHour = Number(parts.slice(0, 2));
        var zoneMinute = Number(parts.slice(2, 4));
        if (zoneHour > 23 || zoneMinute > 59) return NaN;
        offsetMinutes = sign * (zoneHour * 60 + zoneMinute);
      }
      return Date.UTC(year, month - 1, day, hour, minute, second) - offsetMinutes * 60000;
    }

    var parsed = Date.parse(raw);
    return Number.isFinite(parsed) ? parsed : NaN;
  }
  function rankProducts(products, answers, currency) {
    var limits = [100000, 150000, 250000, 400000, Infinity];
    var budget = limits[answers.budget] === undefined ? Infinity : limits[answers.budget];
    var portable = answers.purpose === 2 || answers.placement === 2;
    var shortThrow = answers.placement === 0;
    var fourK = answers.resolution === 0;
    return products.filter(function (p) { return p.available; }).map(function (p) {
      var unmet = [], score = 0;
      if (currency === 'JPY' && p.finalPrice / 100 > budget) unmet.push('予算の上限を超えます');
      if (portable && !p.portable) unmet.push('持ち運び向けではありません');
      if (shortThrow && !p.shortThrow) unmet.push('壁から投影距離が必要です');
      if (fourK && !p.fourK) unmet.push('4K画質ではありません');
      if (answers.ambient === 2) score += p.brightness * 3;
      if (answers.purpose === 0 && p.fourK) score += 4;
      if (answers.purpose === 1) score += p.dailyPriority;
      if (portable && p.portable) score += 4;
      if (answers.resolution === 1 && !p.fourK) score += 2;
      score += p.priority;
      return { product: p, unmet: unmet, score: score };
    }).sort(function (a, b) {
      return a.unmet.length - b.unmet.length || b.score - a.score || a.product.finalPrice - b.product.finalPrice;
    });
  }
  function normalizeCode(value) { return String(value || '').trim().toLowerCase(); }
  function verifyDiscountCode(cart, code) {
    var expected = normalizeCode(code);
    if (!expected) return false;
    return (cart.discount_codes || []).some(function (entry) {
      return normalizeCode(entry.code) === expected && entry.applicable !== false;
    });
  }
  function applicableDiscountCodes(cart) {
    return (cart.discount_codes || []).filter(function (entry) {
      return entry && entry.applicable !== false && normalizeCode(entry.code);
    });
  }
  function verifyExclusiveDiscountCode(cart, code) {
    var expected = normalizeCode(code);
    if (!expected) return applicableDiscountCodes(cart).length === 0;
    var applicable = applicableDiscountCodes(cart);
    return applicable.length === 1 && normalizeCode(applicable[0].code) === expected;
  }
  function findMarkedLine(cart, variantId, marker, value) {
    return (cart.items || []).find(function (item) {
      return String(item.variant_id) === String(variantId) && item.properties && item.properties[marker] === value;
    });
  }
  var logic = { money: money, discountAmount: discountAmount, rankProducts: rankProducts, verifyDiscountCode: verifyDiscountCode, verifyExclusiveDiscountCode: verifyExclusiveDiscountCode };
  if (typeof module !== 'undefined' && module.exports) module.exports = logic;
  if (typeof window === 'undefined' || !window.customElements) return;

  // Shopify theme editor can replace either the whole section or only its inner HTML.
  // Keep a document-level bridge so the newest server-rendered settings are always reparsed.
  if (!window.__jmgoSaleEditorBridgeV4) {
    window.__jmgoSaleEditorBridgeV4 = true;
    var refreshTimers = new WeakMap();
    var refreshRoot = function (root) {
      if (!root || typeof root.refreshEditorPreview !== 'function') return;
      var oldTimer = refreshTimers.get(root);
      if (oldTimer) clearTimeout(oldTimer);
      var timer = setTimeout(function () {
        refreshTimers.delete(root);
        if (root.isConnected && typeof root.refreshEditorPreview === 'function') root.refreshEditorPreview();
      }, 0);
      refreshTimers.set(root, timer);
    };
    var collectEditorRoots = function (event) {
      var roots = [];
      var sectionId = event && event.detail && event.detail.sectionId ? String(event.detail.sectionId) : '';
      if (sectionId) {
        var wrapper = document.getElementById('shopify-section-' + sectionId);
        if (wrapper) roots = roots.concat(Array.from(wrapper.querySelectorAll('jmgo-special-sale')));
        roots = roots.concat(Array.from(document.querySelectorAll('jmgo-special-sale[data-section-id="' + CSS.escape(sectionId) + '"]')));
      }
      if (event && event.target) {
        var scope = event.target;
        if (scope.matches && scope.matches('jmgo-special-sale')) roots.push(scope);
        if (scope.querySelectorAll) roots = roots.concat(Array.from(scope.querySelectorAll('jmgo-special-sale')));
        var closestRoot = scope.closest && scope.closest('jmgo-special-sale');
        if (closestRoot) roots.push(closestRoot);
      }
      if (!roots.length) roots = Array.from(document.querySelectorAll('jmgo-special-sale[data-design-mode="true"]'));
      return Array.from(new Set(roots));
    };
    var refreshEditorSection = function (event) {
      [0, 60, 220, 650].forEach(function (delay) {
        setTimeout(function () { collectEditorRoots(event).forEach(refreshRoot); }, delay);
      });
    };
    document.addEventListener('shopify:section:load', refreshEditorSection);
    document.addEventListener('shopify:section:select', refreshEditorSection);
    document.addEventListener('shopify:section:reorder', refreshEditorSection);
    document.addEventListener('shopify:block:select', refreshEditorSection);
    document.addEventListener('shopify:block:deselect', refreshEditorSection);

    if (window.Shopify && Shopify.designMode && document.documentElement) {
      var editorDomObserver = new MutationObserver(function (mutations) {
        var roots = [];
        mutations.forEach(function (mutation) {
          if (mutation.type === 'characterData') {
            var parent = mutation.target && mutation.target.parentElement;
            var config = parent && parent.closest && parent.closest('[data-sale-config]');
            var root = config && config.closest && config.closest('jmgo-special-sale');
            if (root) roots.push(root);
            return;
          }
          Array.from(mutation.addedNodes || []).forEach(function (node) {
            if (!node || node.nodeType !== 1) return;
            if (node.matches && node.matches('jmgo-special-sale')) roots.push(node);
            if (node.querySelectorAll) roots = roots.concat(Array.from(node.querySelectorAll('jmgo-special-sale')));
            if (node.matches && node.matches('[data-sale-config]')) {
              var owner = node.closest('jmgo-special-sale');
              if (owner) roots.push(owner);
            }
            if (node.querySelector) {
              var addedConfig = node.querySelector('[data-sale-config]');
              var addedOwner = addedConfig && addedConfig.closest('jmgo-special-sale');
              if (addedOwner) roots.push(addedOwner);
            }
          });
        });
        Array.from(new Set(roots)).forEach(refreshRoot);
      });
      editorDomObserver.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    }
  }

  if (customElements.get('jmgo-special-sale')) return;

  class JMGOSpecialSale extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-sale-config]').textContent);
      this.products = this.config.products;
      this.questions = this.config.questions;
      this.step = 0;
      this.answers = {};
      this.busy = false;
      this.added = new Set();
      this.controller = new AbortController();
      this.addEventListener('click', this.onClick.bind(this), { signal: this.controller.signal });
      this.addEventListener('change', this.onChange.bind(this), { signal: this.controller.signal });
      this.products.forEach((p) => this.updateCard(p));
      this.applyProductJumpColors();
      this.renderQuiz();
      this.refreshAvailability();
      if (this.dataset.designMode === 'true') this.installEditorObserver();
      this.timer = setInterval(() => this.refreshAvailability(), 30000);
      document.addEventListener('shopify:block:select', (event) => {
        var card = event.target.closest && event.target.closest('[data-sale-product]');
        if (card && this.contains(card)) this.scrollTo(card.id);
      }, { signal: this.controller.signal });
      // The existing theme rewrites UTM links, including anchors. Scroll by data ID instead.
      var hash = location.hash.slice(1);
      try { hash = decodeURIComponent(hash); } catch (_) { hash = ''; }
      hash = hash.split('?')[0];
      if (hash && this.querySelector('[id="' + CSS.escape(hash) + '"]')) requestAnimationFrame(() => this.scrollTo(hash, false));
    }
    scheduleEditorRefresh() {
      if (this.editorRefreshQueued) return;
      this.editorRefreshQueued = true;
      requestAnimationFrame(() => {
        this.editorRefreshQueued = false;
        this.refreshEditorPreview();
      });
    }
    installEditorObserver() {
      if (this.editorObserver) return;
      this.editorObserver = new MutationObserver((mutations) => {
        if (this.editorRefreshRunning) return;
        var relevant = mutations.some((mutation) => {
          var targetElement = mutation.target && mutation.target.nodeType === 1 ? mutation.target : mutation.target && mutation.target.parentElement;
          if (targetElement && targetElement.closest && targetElement.closest('[data-sale-config]')) return true;
          return Array.from(mutation.addedNodes || []).some((node) => {
            if (node.nodeType !== 1) return false;
            return (node.matches && node.matches('[data-sale-config]')) || (node.querySelector && node.querySelector('[data-sale-config]'));
          });
        });
        if (relevant) this.scheduleEditorRefresh();
      });
      this.editorObserver.observe(this, { childList: true, subtree: true, characterData: true });
    }
    applyProductJumpColors() {
      (this.products || []).forEach((p) => {
        var jump = this.querySelector('[data-sale-product-jump="' + p.id + '"]');
        if (!jump) return;
        var domColor = String(jump.getAttribute('data-sale-jump-color') || '').trim();
        var color = domColor || String(p.jumpColor || '').trim();
        if (color) {
          jump.style.setProperty('--sale-product-jump', color);
          jump.style.setProperty('background', color, 'important');
          jump.style.setProperty('background-color', color, 'important');
        } else {
          jump.style.removeProperty('--sale-product-jump');
          jump.style.removeProperty('background');
          jump.style.removeProperty('background-color');
        }
      });
    }
    refreshEditorPreview() {
      var configNode = this.querySelector('[data-sale-config]');
      if (!configNode) return;
      try {
        this.editorRefreshRunning = true;
        var nextConfig = JSON.parse(configNode.textContent);
        this.config = nextConfig;
        this.products = nextConfig.products || [];
        this.questions = nextConfig.questions || [];
        this.step = Math.min(this.step || 0, this.questions.length);
        this.applyProductJumpColors();
        this.products.forEach((p) => this.updateCard(p));
        this.renderQuiz();
        this.refreshAvailability();
      } catch (_) {
        // Shopify may fire while replacing the section. Global editor retries handle the settled DOM.
      } finally {
        this.editorRefreshRunning = false;
      }
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.editorObserver) this.editorObserver.disconnect();
      clearInterval(this.timer);
      this.initialized = false;
    }
    node(selector) { return this.querySelector(selector); }
    isOpen() {
      var c = this.config, now = Date.now();
      if (!c.enabled || !c.confirmed) return false;
      var start = parseSaleDate(c.start), end = parseSaleDate(c.end);
      if ((c.start && !Number.isFinite(start)) || (c.end && !Number.isFinite(end))) return false;
      if (start !== null && end !== null && end <= start) return false;
      if (start !== null && now < start) return false;
      if (end !== null && now >= end) return false;
      return Boolean(c.marker && c.campaign);
    }
    refreshAvailability() {
      this.open = this.isOpen();
      this.products.forEach((p) => this.updateButton(p));
      var node = this.node('[data-sale-open-state]');
      if (node) {
        var end = parseSaleDate(this.config.end);
        node.textContent = this.open ? (this.config.offerStatusOpen || 'このページの購入ボタンから追加特典を適用します。') : Number.isFinite(end) && Date.now() >= end ? (this.config.offerStatusEnded || 'このセールは終了しました。') : (this.config.offerStatusBefore || 'セールの購入受付は開始前です。');
      }
    }
    selected(p) { return p.variants.find((v) => String(v.id) === String(p.selected)) || p.variants[0]; }
    updateCard(p) {
      var v = this.selected(p), card = this.node('[data-sale-product="' + p.id + '"]');
      if (!v || !card) return;
      var official = Number(v.officialSale || 0) > 0 ? Number(v.officialSale) : Number(p.officialSale || 0) > 0 ? Number(p.officialSale) : Number(v.price);
      var manualSpecial = Number(v.specialSale || 0);
      var saving;
      if (manualSpecial > 0) {
        p.finalPrice = manualSpecial;
        saving = Math.max(0, official - manualSpecial);
      } else {
        saving = discountAmount(official, p.rate, this.config.currency);
        p.finalPrice = official - saving;
      }
      p.available = v.available && !p.requiresPlan;
      var regular = v.compareAt > official ? v.compareAt : this.config.currency === 'JPY' && p.regular > official ? p.regular : Number(v.price) > official ? Number(v.price) : 0;
      card.querySelector('[data-regular-row]').hidden = !regular;
      card.querySelector('[data-regular]').textContent = money(regular, this.config.currency);
      card.querySelector('[data-base-price]').textContent = money(official, this.config.currency);
      card.querySelector('[data-saving]').textContent = money(saving, this.config.currency);
      card.querySelector('[data-final-price]').textContent = money(p.finalPrice, this.config.currency);
      var detail = card.querySelector('[data-detail]');
      var url = new URL(p.url, location.origin); url.searchParams.set('variant', v.id); detail.href = url.pathname + url.search;
      var img = card.querySelector('[data-product-image]');
      if (img && !p.customImage && v.image) { img.src = v.image; img.removeAttribute('srcset'); }
      this.updateButton(p);
    }
    updateButton(p) {
      var card = this.node('[data-sale-product="' + p.id + '"]');
      if (!card) return;
      var button = card.querySelector('[data-sale-cart]'), v = this.selected(p);
      if (!v) return;
      var already = this.added.has(p.id + ':' + v.id);
      var activeCode = String(v.discountCode || p.code || this.config.code || '').trim();
      var needsCode = p.rate > 0 || Number(v.specialSale || 0) > 0;
      var configured = !needsCode || Boolean(activeCode);
      button.disabled = this.busy || (!already && (!this.open || !p.available || !configured));
      button.textContent = already ? 'カートを確認する' : this.busy ? '処理中…' : !p.available ? '売り切れ・購入不可' : !this.open || !configured ? '受付開始前' : this.config.cartLabel;
    }
    onChange(event) {
      if (!event.target.matches('[data-sale-variant]')) return;
      var p = this.products.find((x) => x.id === event.target.dataset.saleVariant);
      if (p) { p.selected = event.target.value; this.updateCard(p); if (this.step === this.questions.length) this.renderResults(); }
    }
    onClick(event) {
      var answer = event.target.closest('[data-sale-answer]');
      if (answer) {
        this.answers[this.questions[this.step].key] = Number(answer.dataset.saleAnswer);
        this.renderQuiz(); return;
      }
      var next = event.target.closest('[data-sale-next]');
      if (next) {
        if (this.step === this.questions.length) { this.step = 0; this.answers = {}; }
        else if (this.answers[this.questions[this.step].key] !== undefined) this.step++;
        this.renderQuiz(); return;
      }
      if (event.target.closest('[data-sale-back]')) { this.step = Math.max(0, this.step - 1); this.renderQuiz(); return; }
      var scroll = event.target.closest('[data-sale-scroll]');
      if (scroll) { event.preventDefault(); this.scrollTo(scroll.dataset.saleScroll); return; }
      var savePage = event.target.closest('[data-sale-save-page]');
      if (savePage) { event.preventDefault(); this.savePage(); return; }
      var copyUrl = event.target.closest('[data-sale-copy-url]');
      if (copyUrl) { event.preventDefault(); this.copyPageUrl(); return; }
      var cart = event.target.closest('[data-sale-cart]');
      if (cart) { event.preventDefault(); this.addToCart(cart.dataset.saleCart); }
    }
    pageUrl() {
      // Keep the secret page path but remove preview/UTM/query fragments from the saved URL.
      return location.origin + location.pathname;
    }
    async writeClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
      }
      var area = document.createElement('textarea');
      area.value = text; area.setAttribute('readonly', '');
      area.style.position = 'fixed'; area.style.opacity = '0'; area.style.pointerEvents = 'none';
      document.body.appendChild(area); area.select();
      var copied = false;
      try { copied = document.execCommand('copy'); } catch (_) { copied = false; }
      area.remove();
      return copied;
    }
    saveStatus(message, isError) {
      var node = this.node('[data-sale-save-status]');
      if (!node) return;
      node.textContent = message;
      node.classList.toggle('is-error', Boolean(isError));
    }
    isMobileDevice() {
      return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || (matchMedia('(pointer: coarse)').matches && matchMedia('(max-width: 900px)').matches);
    }
    async copyPageUrl() {
      var copied = await this.writeClipboard(this.pageUrl()).catch(function () { return false; });
      this.saveStatus(copied ? 'URLをコピーしました。' : 'URLをコピーできませんでした。ブラウザのアドレス欄から保存してください。', !copied);
    }
    async savePage() {
      var url = this.pageUrl();
      var copied = await this.writeClipboard(url).catch(function () { return false; });
      if (this.isMobileDevice() && navigator.share) {
        try {
          await navigator.share({ title: document.title, url: url });
          this.saveStatus('共有メニューを開きました。ブックマーク追加・ホーム画面追加など、お使いのブラウザの保存方法を選んでください。');
          return;
        } catch (error) {
          if (error && error.name !== 'AbortError') this.saveStatus(copied ? 'URLをコピーしました。ブラウザの共有メニューからブックマークまたはホーム画面に追加できます。' : 'ブラウザの共有メニューからブックマークまたはホーム画面に追加してください。');
          else if (copied) this.saveStatus('URLをコピーしました。共有をキャンセルした場合も、コピーしたURLから再訪できます。');
          return;
        }
      }
      var isMac = /Mac|iPhone|iPad|iPod/i.test(navigator.platform || navigator.userAgent);
      var shortcut = isMac ? '⌘ + D' : 'Ctrl + D';
      this.saveStatus((copied ? 'URLをコピーしました。' : '') + ' ブックマークに保存する場合は ' + shortcut + ' を押してください。');
    }
    scrollTo(id, smooth) {
      var target = this.node('[id="' + CSS.escape(id) + '"]');
      if (!target) return;
      this.querySelectorAll('.is-recommended').forEach((x) => x.classList.remove('is-recommended'));
      if (target.matches('[data-sale-product]')) target.classList.add('is-recommended');
      target.scrollIntoView({ behavior: smooth !== false && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto', block: 'start' });
    }
    renderQuiz() {
      if (!this.node('[data-sale-quiz]') || !this.questions.length) return;
      var done = this.step === this.questions.length;
      this.node('[data-sale-questions]').hidden = done;
      this.node('[data-sale-results-wrap]').hidden = !done;
      this.node('[data-sale-step]').textContent = done ? 'YOUR SELECTION' : 'QUESTION ' + (this.step + 1) + ' / ' + this.questions.length;
      var progress = this.node('[data-sale-progress]'); progress.replaceChildren();
      this.questions.forEach((q, i) => { var s = document.createElement('span'); s.className = i <= this.step ? 'is-active' : ''; progress.append(s); });
      var next = this.node('[data-sale-next]'); next.textContent = done ? 'もう一度選ぶ' : this.step === this.questions.length - 1 ? 'おすすめを見る →' : '次の質問へ →';
      next.disabled = !done && this.answers[this.questions[this.step].key] === undefined;
      this.node('[data-sale-back]').disabled = this.step === 0;
      if (done) this.renderResults();
      else {
        var q = this.questions[this.step]; this.node('[data-sale-question]').textContent = q.heading;
        var choices = this.node('[data-sale-choices]'); choices.replaceChildren();
        q.options.forEach((label, i) => { if (!label) return; var b = document.createElement('button'); b.type = 'button'; b.className = 'jmgo-sale__choice'; b.dataset.saleAnswer = i; b.setAttribute('aria-pressed', String(this.answers[q.key] === i)); b.textContent = label; choices.append(b); });
      }
    }
    renderResults() {
      var ranked = rankProducts(this.products, this.answers, this.config.currency), exact = ranked.filter((r) => !r.unmet.length);
      var chosen = (exact.length ? exact : ranked).slice(0, this.config.resultCount);
      this.node('[data-sale-result-title]').textContent = !ranked.length ? '現在、購入可能な候補がありません' : exact.length ? 'あなたにおすすめの製品' : '条件を見直す際の候補';
      var note = exact.length ? '選択した条件に合う候補です。製品を選ぶと下の購入欄へ移動します。' : ranked.length ? 'すべての条件を満たす機種がありません。候補ごとの違いをご確認ください。' : '在庫・対象商品の設定をご確認ください。';
      if (this.answers.ambient === 2) note += ' 日中の利用には遮光などの環境調整もご検討ください。';
      if (this.config.currency !== 'JPY') note += ' 円以外の通貨では予算条件を除いて提案しています。';
      this.node('[data-sale-result-note]').textContent = note;
      var results = this.node('[data-sale-results]'); results.replaceChildren();
      chosen.forEach((r) => {
        var p = r.product, b = document.createElement('button'); b.type = 'button'; b.className = 'jmgo-sale__result'; b.dataset.saleScroll = p.anchor;
        if (p.jumpColor) { b.style.setProperty('--sale-product-jump', p.jumpColor); b.style.setProperty('background-color', p.jumpColor, 'important'); }
        var badge = document.createElement('span'); badge.className = 'jmgo-sale__eyebrow'; badge.textContent = r.unmet.length ? '条件の見直し候補' : 'RECOMMENDED';
        var title = document.createElement('strong'); title.textContent = p.name;
        var desc = document.createElement('span'); desc.className = 'jmgo-sale__small'; desc.textContent = p.description;
        var reason = document.createElement('span'); reason.className = 'jmgo-sale__small'; reason.textContent = r.unmet.length ? r.unmet.join('／') : '画質・設置・予算の条件に合う候補です。';
        var price = document.createElement('span'); price.textContent = '特典適用後 ' + money(p.finalPrice, this.config.currency);
        var action = document.createElement('span'); action.textContent = 'この製品の購入欄へ ↓';
        b.append(badge, title, desc, reason, price, action); results.append(b);
      });
    }
    async request(path, data) {
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var response = await fetch(base + path, { method: data === undefined ? 'GET' : 'POST', credentials: 'same-origin', cache: 'no-store', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, ...(data === undefined ? {} : { body: JSON.stringify(data) }) });
      var result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'カートの更新に失敗しました。');
      return result;
    }
    async addToCart(id) {
      var p = this.products.find((x) => x.id === id); if (!p || this.busy) return;
      var v = this.selected(p); if (!v) return;
      var identity = p.id + ':' + v.id;
      if (this.added.has(identity)) { location.assign(this.config.cartUrl); return; }
      if (!this.isOpen() || !p.available) return;
      var card = this.node('[data-sale-product="' + p.id + '"]'), status = card.querySelector('[data-sale-status]');
      var mayHaveAdded = false;
      this.busy = true; status.classList.remove('is-error'); status.textContent = 'LP専用割引を適用しています…'; this.products.forEach((x) => this.updateButton(x));
      try {
        var before = await this.request('cart.js');
        if (before.currency !== this.config.currency) throw new Error('通貨が変更されています。ページを再読み込みしてからお試しください。');
        var code = String(v.discountCode || p.code || this.config.code || '').trim();
        if ((p.rate > 0 || Number(v.specialSale || 0) > 0) && !code) throw new Error('選択中のバリエーションにLP専用ディスカウントコードが未設定です。');

        // Exclusive LP promotion: discard any coupon code already attached to the cart
        // (including KOL codes), then apply only this LP's code after the item is added.
        await this.request('cart/update.js', { discount: '' });
        var clearedCart = await this.request('cart.js');
        if (applicableDiscountCodes(clearedCart).length) throw new Error('既存クーポンを解除できませんでした。カートでクーポンを外してから再度お試しください。');

        var properties = {}; properties[this.config.marker] = this.config.campaign;
        // Never repeat this mutation automatically: an uncertain response may still add merchandise.
        mayHaveAdded = true;
        await this.request('cart/add.js', { items: [{ id: v.id, quantity: 1, properties: properties }] });
        this.added.add(identity);
        if (code) await this.request('cart/update.js', { discount: code });
        var cart = await this.request('cart.js');
        var markedLine = findMarkedLine(cart, v.id, this.config.marker, this.config.campaign);
        var verified = Boolean(markedLine) && verifyExclusiveDiscountCode(cart, code);
        if (!verified) {
          status.classList.add('is-error'); status.replaceChildren(document.createTextNode('商品をカートに追加しましたが、LP専用割引だけが適用された状態を確認できませんでした。カートの割引表示をご確認ください。 '));
          var link = document.createElement('a'); link.href = this.config.cartUrl; link.textContent = 'カートを確認'; status.append(link); return;
        }
        status.textContent = 'LP専用割引のみが適用されました。カートへ移動します。';
        location.assign(this.config.cartUrl);
      } catch (error) {
        status.classList.add('is-error');
        if (mayHaveAdded) {
          this.added.add(identity);
          status.textContent = '処理結果を確認できませんでした。重複追加を避けるため、カートをご確認ください。';
        } else status.textContent = error.message || '処理に失敗しました。時間をおいてお試しください。';
      } finally { this.busy = false; this.refreshAvailability(); }
    }
  }
  customElements.define('jmgo-special-sale', JMGOSpecialSale);
})();
